/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Genius_Agent_Receipt_RoleInputs */

const tr_landing_genius_agent_receipt_role = /** @type {(inputs: Landing_Genius_Agent_Receipt_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fiş ve belge okuma`)
};

const en_landing_genius_agent_receipt_role = /** @type {(inputs: Landing_Genius_Agent_Receipt_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`receipt reading`)
};

const de_landing_genius_agent_receipt_role = /** @type {(inputs: Landing_Genius_Agent_Receipt_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belege lesen`)
};

const ru_landing_genius_agent_receipt_role = /** @type {(inputs: Landing_Genius_Agent_Receipt_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`чтение чеков`)
};

/**
* | output |
* | --- |
* | "receipt reading" |
*
* @param {Landing_Genius_Agent_Receipt_RoleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_genius_agent_receipt_role = /** @type {((inputs?: Landing_Genius_Agent_Receipt_RoleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Genius_Agent_Receipt_RoleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_genius_agent_receipt_role(inputs)
	if (locale === "de") return de_landing_genius_agent_receipt_role(inputs)
	if (locale === "ru") return ru_landing_genius_agent_receipt_role(inputs)
	return tr_landing_genius_agent_receipt_role(inputs)
});